import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  private readonly CONSENT_KEY = 'oak-cookie-consent';
  private readonly CONSENT_VERSION = '1.0';

  constructor() {}

  hasConsent(): boolean {
    const consent = this.getConsentData();
    return consent !== null && consent.version === this.CONSENT_VERSION;
  }

  giveConsent(): void {
    const consentData = {
      version: this.CONSENT_VERSION,
      timestamp: new Date().toISOString(),
      accepted: true,
    };
    localStorage.setItem(this.CONSENT_KEY, JSON.stringify(consentData));
  }

  private getConsentData(): { version: string; timestamp: string; accepted: boolean } | null {
    try {
      const data = localStorage.getItem(this.CONSENT_KEY);
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  }
}
